export const COMMENT_ATTACHMENT_EXTENSIONS = [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'odt',
    'pdf',
    'csv',
    'png',
    'jpg',
    'jpeg',
    'gif',
    'xml',
    'txt',
    'rar',
    'zip',
    '7z',
    'ifc',
];
